export enum AdminCatalogFeedbackApiTag {}

export const adminCatalogFeedbackApiTags = Object.values(AdminCatalogFeedbackApiTag);
